import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e411w_07
 * @category 고장분석현황[전체] - 처리내용별
 */

export class ProcessContentModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   *  현장명
   *
   * **data type** varchar(?)
   */
  readonly actcd : string;

  /**
   *  현장명
   *
   * **data type** varchar(?)
   */
  readonly actnm : string;

  /**
   *  처리내용
   *
   * **data type** varchar(?)
   */
  readonly resunm : string;

  /**
   *  고장건수
   *
   * **data type** varchar(?)
   */
  readonly tot: string;

  /**
   *  호기명
   *
   * **data type** varchar(?)
   */
  readonly equpnm: string;


  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.equpnm = data.equpnm || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.resunm = data.resunm || '';
    this.tot = data.tot || '';


    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
